import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { PlatformAssessmentDetailScreen } from '@/features/assessments/components/platform/AssessmentDetailScreen';

const searchSchema = z.object({
  tab: z.enum(['overview', 'questions', 'scoring']).catch('overview').optional(),
});

export const Route = createFileRoute('/_staff/admin/platform/assessments/$templateId/')({
  validateSearch: searchSchema,
  component: Wrap,
});

function Wrap() {
  const { templateId } = useParams({
    from: '/_staff/admin/platform/assessments/$templateId/',
  });
  const { tab } = useSearch({ from: '/_staff/admin/platform/assessments/$templateId/' });
  return <PlatformAssessmentDetailScreen templateId={templateId} initialTab={tab ?? 'overview'} />;
}
